// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* target main div when side bar extend*/

.report-main{
    text-align: center;
    width: calc(100vw - 200px);
    height: calc(100vh - 38px);
    background-color: #F4F9FF; 
}

/* target min div when side bar shrink*/
.report-min{
    text-align: center;
    width: calc(100vw - 100px);
    height: calc(100vh - 38px);
    background-color: #F4F9FF; 
}


.report-div{
    background-color: #FFFFFF;
    margin-left: 15px;
    position: absolute;
    margin-top: 15px;
    width: calc(100vw - 265px);
    height: calc(100vh - 110px);
    padding: 20px;
    box-shadow: 0px 0px 7px lightblue;
    border-radius: 5px;
    border: none;
}

.report-div-min{
    background-color: #FFFFFF;
    margin-left: 20px;
    position: absolute;
    margin-top: 30px;
    width: calc(100vw - 200px);
    height: calc(100vh - 120px);
    padding: 20px;
    box-shadow: 0px 0px 7px lightblue;
    border-radius: 10px;
    border: none;
}

.report-content{
    display: flex ;
    justify-content: center;
    align-items: center;
}

.report-drop{
    width:300px !important;
}

.report-content >div{
    margin-right: 30px;
    margin-top: 30px;
    
}

.title-report{
    border-bottom: 2px solid lightgray;
    padding-bottom: 20px;
    display: flex;
    justify-content: space-between;
    overflow: auto;
    padding-top: 10px;
    font-size: 25px;
}
.btn-download{
    font-size: 11px !important; 
}

/* to target the drop down div  */
.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input{
    padding: 10px 0px 10px 0px !important;
}

.date-range-wrapper1{
    position: absolute;
    /* top: 100%; */
    margin-left: -300px;
    margin-top: 10px;
    border: none !important;
    background-color: #F4F9FF !important;
}
.date-range-container1{
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    margin-top: 10px;
    left: 0;
    background-color:  #FFFFFF ;
    /* border: 1px solid #ccc; */
    padding: 10px;
    z-index: 1;
    
    box-shadow: 0px 0px 5px grey;
    border: none;
}
.btn-effect{
    font-size: 11px !important;
}

.css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root{
    margin-top: -5px;
    font-size: 13px !important;
}

.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select{
    font-size: 13px;
}

.css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root{
    font-size: 13px !important;
}

@media screen and (max-width:1074px) {
  .btn-download{
    margin-top: 10px !important; 
}  
}

@media screen and (max-width:778px) {
    .report-content{
    flex-direction: column
    }
    .date-range-wrapper1{
        margin-left: -100px !important;
    }

  }

.css-e47596-MuiDateRangeCalendar-root >div:first-child{
    display: none;
}

.select-btn-div{
    display: flex;
    flex-direction: column;
    justify-content: center !important;
}


.select-btn{
    font-size: 11px !important;
    width: -moz-fit-content !important;
    width: fit-content !important;
    margin-top: 10px !important;
    /* text-align: center; */
    margin-left: auto !important;
    margin-right: auto !important;
}

.clear-btn{
    font-size: 11px !important;
    width: max-content !important; 
}

@media screen and (max-height:645px) {
    .report-div{
        overflow: auto;
    }
    
}`, "",{"version":3,"sources":["webpack://./src/components/Report/Report.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA,uCAAuC;AACvC;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,2BAA2B;IAC3B,aAAa;IACb,iCAAiC;IACjC,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,2BAA2B;IAC3B,aAAa;IACb,iCAAiC;IACjC,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;IACI,kCAAkC;IAClC,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,0BAA0B;AAC9B;;AAEA,iCAAiC;AACjC;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,OAAO;IACP,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;IACb,UAAU;;IAEV,4BAA4B;IAC5B,YAAY;AAChB;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;EACE;IACE,2BAA2B;AAC/B;AACA;;AAEA;IACI;IACA;IACA;IACA;QACI,8BAA8B;IAClC;;EAEF;;AAEF;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kCAAkC;AACtC;;;AAGA;IACI,0BAA0B;IAC1B,kCAA6B;IAA7B,6BAA6B;IAC7B,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;IAClB;;AAEJ","sourcesContent":["/* target main div when side bar extend*/\n\n.report-main{\n    text-align: center;\n    width: calc(100vw - 200px);\n    height: calc(100vh - 38px);\n    background-color: #F4F9FF; \n}\n\n/* target min div when side bar shrink*/\n.report-min{\n    text-align: center;\n    width: calc(100vw - 100px);\n    height: calc(100vh - 38px);\n    background-color: #F4F9FF; \n}\n\n\n.report-div{\n    background-color: #FFFFFF;\n    margin-left: 15px;\n    position: absolute;\n    margin-top: 15px;\n    width: calc(100vw - 265px);\n    height: calc(100vh - 110px);\n    padding: 20px;\n    box-shadow: 0px 0px 7px lightblue;\n    border-radius: 5px;\n    border: none;\n}\n\n.report-div-min{\n    background-color: #FFFFFF;\n    margin-left: 20px;\n    position: absolute;\n    margin-top: 30px;\n    width: calc(100vw - 200px);\n    height: calc(100vh - 120px);\n    padding: 20px;\n    box-shadow: 0px 0px 7px lightblue;\n    border-radius: 10px;\n    border: none;\n}\n\n.report-content{\n    display: flex ;\n    justify-content: center;\n    align-items: center;\n}\n\n.report-drop{\n    width:300px !important;\n}\n\n.report-content >div{\n    margin-right: 30px;\n    margin-top: 30px;\n    \n}\n\n.title-report{\n    border-bottom: 2px solid lightgray;\n    padding-bottom: 20px;\n    display: flex;\n    justify-content: space-between;\n    overflow: auto;\n    padding-top: 10px;\n    font-size: 25px;\n}\n.btn-download{\n    font-size: 11px !important; \n}\n\n/* to target the drop down div  */\n.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input{\n    padding: 10px 0px 10px 0px !important;\n}\n\n.date-range-wrapper1{\n    position: absolute;\n    /* top: 100%; */\n    margin-left: -300px;\n    margin-top: 10px;\n    border: none !important;\n    background-color: #F4F9FF !important;\n}\n.date-range-container1{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: absolute;\n    margin-top: 10px;\n    left: 0;\n    background-color:  #FFFFFF ;\n    /* border: 1px solid #ccc; */\n    padding: 10px;\n    z-index: 1;\n    \n    box-shadow: 0px 0px 5px grey;\n    border: none;\n}\n.btn-effect{\n    font-size: 11px !important;\n}\n\n.css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root{\n    margin-top: -5px;\n    font-size: 13px !important;\n}\n\n.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select{\n    font-size: 13px;\n}\n\n.css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root{\n    font-size: 13px !important;\n}\n\n@media screen and (max-width:1074px) {\n  .btn-download{\n    margin-top: 10px !important; \n}  \n}\n\n@media screen and (max-width:778px) {\n    .report-content{\n    flex-direction: column\n    }\n    .date-range-wrapper1{\n        margin-left: -100px !important;\n    }\n\n  }\n\n.css-e47596-MuiDateRangeCalendar-root >div:first-child{\n    display: none;\n}\n\n.select-btn-div{\n    display: flex;\n    flex-direction: column;\n    justify-content: center !important;\n}\n\n\n.select-btn{\n    font-size: 11px !important;\n    width: fit-content !important;\n    margin-top: 10px !important;\n    /* text-align: center; */\n    margin-left: auto !important;\n    margin-right: auto !important;\n}\n\n.clear-btn{\n    font-size: 11px !important;\n    width: max-content !important; \n}\n\n@media screen and (max-height:645px) {\n    .report-div{\n        overflow: auto;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
